import { render, staticRenderFns } from "./Act4cHomepage.vue?vue&type=template&id=958b9a0e&scoped=true"
import script from "./Act4cHomepage.vue?vue&type=script&lang=js"
export * from "./Act4cHomepage.vue?vue&type=script&lang=js"
import style0 from "./Act4cHomepage.vue?vue&type=style&index=0&id=958b9a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958b9a0e",
  null
  
)

export default component.exports